import { createApi } from '@core/fetch'

export default {
  merchantInfo: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/buyProInfoApp'
  )
}
